import { notification } from "antd";
import toastSuccessIcon from "../assets/ToastSuccessIcon.png";
import toastErrorIcon from "../assets/caution.png";
import toastInfoIcon from "../assets/InfoCircle.png";

export const initializeNotification = () => {
  notification.config({
    placement: "topRight",
    duration: 4,
  });

  const originalSuccess = notification.success;
  notification.success = (args) => {
    return originalSuccess({
      ...args,
      icon: (
        <img
          src={toastSuccessIcon}
          alt="success"
          style={{ width: "24px", height: "24px" }}
        />
      ),
    });
  };

  const originalError = notification.error;
  notification.error = (args) => {
    return originalError({
      ...args,
      icon: (
        <img
          src={toastErrorIcon}
          alt="error"
          style={{ width: "24px", height: "24px" }}
        />
      ),
    });
  };

  const originalInfo = notification.info;
  notification.info = (args) => {
    return originalInfo({
      ...args,
      icon: (
        <img
          src={toastInfoIcon}
          alt="info"
          style={{ width: "24px", height: "24px" }}
        />
      ),
    });
  };

  const originalWarning = notification.warning;
  notification.warning = (args) => {
    return originalWarning({
      ...args,
      icon: (
        <img
          src={toastErrorIcon}
          alt="warning"
          style={{ width: "24px", height: "24px" }}
        />
      ),
    });
  };
};
